import { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { Input } from "@/components/ui/input";
import api from "@/lib/api";
import { toast } from "sonner";

export default function DisputeDialog({ open, onOpenChange, booking, isOwner, onDone }) {
  const [type, setType] = useState("dispute");
  const [subject, setSubject] = useState("");
  const [description, setDescription] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (open) { setType("dispute"); setSubject(""); setDescription(""); } }, [open]);
  if (!booking) return null;

  const submit = async () => {
    if (!subject.trim() || !description.trim()) { toast.error("Add a subject and description"); return; }
    setBusy(true);
    try {
      await api.post("/disputes", { booking_id: booking.id, type, subject, description });
      toast.success("Claim submitted — an admin will review it");
      onOpenChange(false);
      onDone?.();
    } catch (e) { toast.error(e.response?.data?.detail || "Failed to submit"); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader><DialogTitle className="font-display tracking-tight">Report a problem</DialogTitle></DialogHeader>
        <p className="text-sm text-muted-foreground -mt-1">{booking.listing_title}</p>
        <div className="flex gap-2 mt-2">
          <button data-testid="dispute-type-dispute" onClick={() => setType("dispute")} className={`flex-1 px-4 py-2.5 rounded-xl border text-sm font-medium transition-colors ${type === "dispute" ? "bg-black text-white border-black" : "bg-white border-black/15 hover:border-black"}`}>Dispute</button>
          {isOwner && (
            <button data-testid="dispute-type-nonreturn" onClick={() => setType("non_return")} className={`flex-1 px-4 py-2.5 rounded-xl border text-sm font-medium transition-colors ${type === "non_return" ? "bg-black text-white border-black" : "bg-white border-black/15 hover:border-black"}`}>Item not returned</button>
          )}
        </div>
        <Input data-testid="dispute-subject" value={subject} onChange={(e) => setSubject(e.target.value)} placeholder="Subject" className="bg-white border-black/10 rounded-xl" />
        <Textarea data-testid="dispute-description" value={description} onChange={(e) => setDescription(e.target.value)} placeholder="Describe what happened…" className="bg-white border-black/10 rounded-xl min-h-24" />
        <button data-testid="submit-dispute-btn" onClick={submit} disabled={busy} className="w-full bg-[#0A0A0A] text-white rounded-full py-3 font-medium hover:bg-[#FF5A00] transition-colors disabled:opacity-60">
          {busy ? "Submitting…" : "Submit claim"}
        </button>
      </DialogContent>
    </Dialog>
  );
}
